import { StandardAssetRaw } from '$components/Asset';
import FadeInSection from '$components/FadeInSection/FadeInSection';
import { ZeroElement } from '$components/ZeroElement';
import { responsiveContentfulSrcset } from '$providers/Assets';
import { LayoutContext } from '$root/src/context';
import cn from 'classnames';
import { HTMLAttributes, useContext, useState } from 'react';

import { IProductSlider } from './';
import { ProductContent } from './ProductContent';
import { ProductImage } from './ProductImage';
import { ProductSlideItem } from './ProductSlideItem';

export function ProductSlider(
  props: IProductSlider & HTMLAttributes<HTMLElement>,
) {
  const { className, content, ...rest } = props;
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);

  const useLayoutStore = useContext(LayoutContext);
  const newHeight = useLayoutStore((state) => state.resized);

  return (
    <FadeInSection>
      <div className="flex flex-row justify-center overflow-hidden">
        <div className={`grid-standard `}>
          <div className={` col-span-4 md:col-span-12`}>
            <div
              //style={{ minHeight: newHeight }}
              className={cn(
                'relative w-full flex flex-col justify-center lg:overflow-hidden items-stretch',
              )}
            >
              {content.map((item, index) => {
                if (
                  item.backgroundAsset !== null &&
                  typeof item.backgroundAsset !== 'undefined'
                ) {
                  const bgAsset = StandardAssetRaw([item.backgroundAsset]);
                  let zeroElement;
                  if (bgAsset !== null && bgAsset.assetType === 'image') {
                    zeroElement = (
                      <ZeroElement
                        fadeDirection={
                          window.innerWidth < 768 ? 'down' : 'left'
                        }
                        index={null}
                        assetType={'image'}
                        type={'static'}
                        imageAsset={responsiveContentfulSrcset({
                          url: bgAsset.url,
                        })}
                        videoAsset={null}
                      />
                    );
                  } else if (
                    bgAsset !== null &&
                    (bgAsset.assetType === 'video' ||
                      bgAsset.assetType === 'videoWithPlaceholder')
                  ) {
                    let videoUrl =
                      bgAsset.videoUrl !== null
                        ? bgAsset.videoUrl
                        : bgAsset.url;
                    zeroElement = (
                      <ZeroElement
                        noDelay={true}
                        fadeDirection={
                          window.innerWidth < 768 ? 'down' : 'left'
                        }
                        index={index}
                        activeSlideIndex={activeSlideIndex}
                        assetType={'video'}
                        type={'static'}
                        imageAsset={null}
                        videoAsset={videoUrl}
                      />
                    );
                  }
                  return (
                    <div
                      style={{ height: newHeight }}
                      key={index}
                      className={cn(
                        index === activeSlideIndex
                          ? 'opacity-100'
                          : 'opacity-0',
                        'productSwirlContainer flex-col absolute left-0 top-0 w-full md:h-full flex md:justify-center items-center lg:overflow-hidden duration-[1600ms]',
                      )}
                    >
                      <div
                        style={{
                          animationName:
                            index === activeSlideIndex
                              ? 'spinner_page'
                              : undefined,
                        }}
                        className={cn(
                          'outerRing absolute left-0 top-0 w-full h-full',
                        )}
                      >
                        {zeroElement}
                      </div>
                    </div>
                  );
                }
              })}
              <div
                className={cn(
                  'flex grow md:h-full w-full flex-col md:flex-row justify-stretch md:justify-between items-center',
                )}
              >
                <div
                  {...rest}
                  className={cn(
                    className,
                    'flex md:h-full pb-3 md:pb-0 w-full md:w-auto flex-col items-start justify-end md:justify-center mt-0',
                  )}
                >
                  {content.map((item, index) => {
                    return (
                      <ProductSlideItem
                        type={'light'}
                        key={index}
                        item={item.text}
                        index={index}
                        active={index === activeSlideIndex}
                        onClick={() => {
                          setActiveSlideIndex(index);
                        }}
                      />
                    );
                  })}
                </div>
                <div
                  className={cn(
                    'flex md:grow-0 md:h-full w-full md:w-1/3 flex-col items-start justify-stretch md:justify-center',
                  )}
                >
                  <div
                    className={cn(
                      'relative block md:flex w-full h-[44vh] md:grow-0 md:h-full items-center justify-end [&>img]:h-full [&>img]:w-[auto] md:[&>img]:h-[auto] md:[&>img]:w-full',
                    )}
                  >
                    {content.map((item, index) => {
                      return (
                        <ProductImage
                          key={index}
                          active={index === activeSlideIndex}
                          index={index}
                          assets={item.assetsCollection.items}
                          coverClass={''}
                        />
                      );
                    })}
                  </div>
                </div>
                <div
                  className={cn(
                    'flex pt-3 md:pt-0 h-full md:h-screen md:grow-0 w-full md:w-1/3 flex-col items-start justify-center',
                  )}
                >
                  <div
                    className={cn(
                      'relative flex w-full h-full items-start md:items-center',
                    )}
                  >
                    {content.map((item, index) => {
                      return (
                        <ProductContent
                          key={index}
                          active={index === activeSlideIndex}
                          index={index}
                          ctas={item.ctaCollection.items}
                          item={item.text}
                          type={item.type}
                        />
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FadeInSection>
  );
}
